import moment from "moment";

export default function getAge(date) {
  return moment().diff(moment(date, "YYYY-MM-DD"), "year");
}
